var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share-title"},[_c('p',{staticClass:"title-sty"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.more)?_c('p',{staticClass:"title-more",on:{"click":_vm.gotoMore}},[_vm._v("更多 >>")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d13f52e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Education/commonView/modelTitle.vue
// module id = null
// module chunks = 